export default __webpack_public_path__ + "static/media/TataAIG.aaf92dc4.svg";